import type { SvgProps } from "../types";

export const TipsSvg = ({
  width = "100px",
  height = width,
  color = "#000000",
}: SvgProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 400 400" fill="none">
      <title>Tips</title>
      <path
        d="M341 67C148.339 290.671 183.5 343.046 131 205.023"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
      />
      <path
        d="M126.678 74.6892C175.762 40.3656 223.672 30.3765 275.706 57.7602C415.664 131.409 354.622 382.384 180.329 356.983C85.4278 343.149 -9.51278 223.621 90.9151 117.034"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
